const isMobilePaidPdp = (isMobileDevice, router) =>
  isMobileDevice && router?.pathname === '/product/[slug]'
  && (router?.query?.utm_medium === 'cpc' || router?.query?.utm_medium === 'affiliate');

export default isMobilePaidPdp;
